import log from 'loglevel';

const navigationMixin = {
  methods: {
    async goto(where) {
      if (!this.commit()) {
        log.info(`${this.name}.goto(${where}): form data is invalid, preventing navigation`);
        return;
      }

      await this.$store.dispatch('uploadRecipe');

      if (!this.$store.state.serverError) {
        this.$store.commit('navigate', where);
      }
    },
  },
  created() {
    this.$eventHub.$on('navigate-attempt', this.goto);
  },
  beforeDestroy() {
    this.$eventHub.$off('navigate-attempt', this.goto);
  },
};

export default navigationMixin;
